module.exports = __webpack_public_path__ + "img/scan_success.dd2b84fb.png";